import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
    const userData = localStorage.getItem("USER_DATA");

    return userData ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
